import CandidatePreScreeningInterview from './CandidatePreScreeningInterview.container';

export default CandidatePreScreeningInterview;
